exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Chip-bb235825{display:inline-block;background:#6982FF;color:#FFF;font-size:13px;padding:7px 10px;border-radius:2px;margin-right:10px}\n", ""]);

// Exports
exports.locals = {
	"Chip": "Chip-bb235825"
};